import { AnimationEventHandler, useRef } from 'react';
import { ReactComponent as ErrorIcon } from '../../icons/warning.svg';
import { ReactComponent as TipIcon } from '../../icons/tip.svg';
import './Notification.scss';
import {
  removeNotification,
  Notification as INotification,
  hideNotification,
} from '../../core/store/notificationsSlice';
import { useAppDispatch } from '../../hooks';
import classNames from 'classnames';
import MiniLoader from '../MiniLoader/MiniLoader';
export const DEFAULT_ERROR = 'Something went wrong, please try again';

interface Props {
  data: INotification;
}

const INTERVAL = 3000;

const Icons = {
  success: <TipIcon className='me-2' />,
  loading: (
    <MiniLoader className='MiniLoader--sm d-flex align-items-center justify-content-center me-2 MiniLoader--Notification MiniLoader--white' />
  ),

  error: <ErrorIcon className='Notification__icon me-2' />,
};

export default function Notification({ data }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  const onAnimationEnd: AnimationEventHandler = (e) => {
    const notificationsBlock = ref.current?.parentElement;
    if (e.animationName === 'fadeIn' && data.state === 'auto-hide') {
      setTimeout(() => {
        dispatch(hideNotification({ id: data.id }));
      }, data.interval || INTERVAL);
    }
    if (e.animationName === 'fadeOut') {
      if (notificationsBlock) {
        notificationsBlock.style.transition = '';
        notificationsBlock.style.transform = `translate3d(0, 0, 0)`;
      }
      dispatch(removeNotification(data.id));
    }
  };

  const onAnimationStart: AnimationEventHandler = (e) => {
    if (e.animationName === 'fadeOut') {
      const notificationsBlock = ref.current?.parentElement;
      if (notificationsBlock) {
        notificationsBlock.style.transition = 'transform 0.5s ease-out';
        notificationsBlock.style.transform = `translate3d(0, ${
          ref.current.offsetHeight + 32
        }px, 0)`;
      }
    }
  };

  return (
    <div
      className={classNames(
        'Notification mb-3 d-flex align-items-start px-2 py-1 text-break animation-forwards',
        {
          fadeIn: data.state === 'auto-hide' || data.state === 'open',
          fadeOut: data.state === 'hide',
          'Notification--error': data.type === 'error',
        }
      )}
      ref={ref}
      onAnimationEnd={onAnimationEnd}
      onAnimationStart={onAnimationStart}
    >
      {Icons[data.type]}
      <span className='text-break'>
        {data.type === 'error' && !data.text ? DEFAULT_ERROR : data.text}
      </span>
    </div>
  );
}
